export const SUPPORT_EMAIL_URL = "mailto:support@futuremoney.co";

export const MAX_PREFETCH_QUERIES = 5;
